export const FEEDBACK_DURATION = 3000;
